export default {
  contactUsSection: {
    title: {
      fr: "Nous contacter",
      en: "Contact us",
    },
  },
  learnMoreSection: {
    title: {
      fr: "En savoir plus",
      en: "Learn more",
    },
  },
  askForDemo: {
    title: {
      fr: "Demander une démo",
      en: "Ask for a demo",
    },
  },
  compatibleDevices: {
    title: {
      fr: "Découvrir",
      en: "Dicover",
    },
    link: "https://www.polynhome.io/equipements-zigbee-compatibles",
  },
};
